<template>
    <div class="modal is-active">
        <div class="modal-background" @click="closeModal"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Enviar link de la sala</p>
                <button class="delete" @click="closeModal"></button>
            </header>
            <section class="modal-card-body">
                <div v-if="closing">
                    <Loading />
                </div>
                <div class="field">
                    <label class="label">Correo electrónico</label>
                    <div class="control">
                        <input class="input" type="email" v-model="email">
                    </div>
                </div>
                <div class="field">
                    <label class="label">Link a compartir</label>
                    <div class="control">
                        {{ link }}
                        <a class="is-pointer mr-1" @click="copyLink">
                            <Icon family="fal" name="fa-copy" />
                        </a>
                    </div>
                </div>
            </section>
            <footer class="modal-card-foot">
                <button class="button is-success" @click="send">
                    Enviar
                </button>
                <button class="button" @click="closeModal">
                    Cancelar
                </button>
                <div v-if="!closing">
                    <p v-if="haveError" class="has-text-danger">{{ error }}</p>
                </div>
            </footer>
        </div>
    </div>
</template>

<script>
//import { RepositoryFactory } from "@/services/api";
import Loading from "@/components/Loading";

export default {
    name: "share-room-modal",
    components: {
        Loading,
    },
    data() {
        return {
            closing: false,
            error: "",
            email: "",
            link: ""
        };
    },
    computed: {
        haveError() {
            return this.error !== "";
        },
    },
    created() {
        this.link = window.location.href;
    },
    methods: {
        closeModal() {
            this.$emit("close");
        },
        async send() {
            if (this.email === "") {
                this.error = "Debe ingresar correo electrónico.";
                return;
            }
        },
        async copyLink() {
            await navigator.clipboard.writeText(this.link);
        }
    },
};
</script>